import { Controller } from "@hotwired/stimulus";

// Um cartão da grade passa a ocupar a linha inteira e volta: o gráfico pequeno vira o
// grande no lugar, sem trocar de tela. O Chart.js redesenha no `resize`.
export default class extends Controller {
  static targets = ["botao"];
  static classes = ["largo"];

  alternar() {
    const largo = this.element.classList.toggle(this.largoClass);

    this.botaoTargets.forEach((botao) => {
      botao.setAttribute("aria-pressed", largo.toString());
      botao.title = largo ? "Reduzir" : "Expandir";
    });

    window.dispatchEvent(new Event("resize"));
  }
}
